import { NotificationContext } from '../contexts/notificationContext'
import { useNotificationState } from './hooks'

/**
 * Provider для управления уведомлениями пользователя
 */
export function NotificationProvider({ children }: { children: React.ReactNode }) {
  const notificationState = useNotificationState()

  return (
    <NotificationContext.Provider value={notificationState}>
      {children}
    </NotificationContext.Provider>
  )
}
